import React from 'react'
import { ActivityIndicator, ActivityIndicatorProps } from 'react-native'

interface SpinnerProps extends ActivityIndicatorProps {
  color?: string
}

// Always default to purple #291180 to avoid ActivityIndicator falling back
// to the browser's default blue on web when color is undefined at runtime.
export const Spinner = ({ color, ...props }: SpinnerProps) => {
  const finalColor = color ?? '#291180'

  return <ActivityIndicator color={finalColor} {...props} />
}
